export default String.raw`
.bannerPromo {
    padding: 0 5%;
    flex-direction: column;
    
    &__wrapper {
        margin-bottom: 20px;
        height: auto;
    }

    &__image {
        height: auto;

        &.mobileImagePromo {
            display: block;
        }
    
        &.desktopImagePromo {
            display: none;
        }

        img {
            max-width: 100%;
        }
    }

    &__texts {
        left: 24px;
        top: 24px;
        width: calc(100% - 48px);
        max-height: calc(100% - 48px);
        gap: 32px;
    }

    &__title {
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
    }

    &__products {
        display: flex !important;
        gap: unset;
    }

    &__placeholder {
        &::after {
            content: 'Mobile';
        }
    }

    .card-product {
        justify-content: space-between !important;

        &__name {
            height: 40px;
        }
    }
}
`